var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice",class:_vm.computedType},[_c('div',{staticClass:"icon"},[(!_vm.type)?_c('InfoIcon'):_vm._e()],1),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }